<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>学生管理</Breadcrumb-item>
        <Breadcrumb-item>兑换记录</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="60" :show-message="false" lable-positon="right">
        <Row :gutter="32">
          <Col :span="6">
          <Form-item label="学生ID" >
            <Input name="uid"
                   v-model="queryParam.uid"></Input>
          </Form-item>
          </Col>
          <Col :span="6">
          <Form-item label="学生姓名" :label-width="75">
            <Input placeholder="支持模糊搜索" name="userNickname"
                   v-model="queryParam.userNickname"></Input>
          </Form-item>
          </Col>
          <Col :span="6">
          <Form-item label="兑换类型">
            <Select v-model.number="queryParam.type" placeholder="全部" @on-change="search" clearable>
              <Option v-for="item in $constant.giveType"
                      :value="item.code" :key="item.code">{{ item.text }}</Option>
            </Select>
          </Form-item>
          </Col>
          <Col :span="6">
          <Form-item label="操作人">
            <Input v-model="queryParam.auditorName" placeholder="支持模糊搜索" name="checkAdmin"></Input>
          </Form-item>
          </Col>
          <Col :span="7" >
          <Form-item label="申请时间">
            <Row>
              <Col span="11">
              <Date-picker type="datetime" format="yyyy-MM-dd HH:mm" placeholder="请选择日期"
                           @on-change="startTimeDateChange"
                           v-model="queryParam.startTimeDate" style="width: 100%;"></Date-picker>
              </Col>
              <Col span="1" style="text-align: center">-</Col>
              <Col span="11">
              <Date-picker type="datetime" format="yyyy-MM-dd HH:mm" placeholder="请选择日期"
                           @on-change="endTimeDateChange"
                           v-model="queryParam.endTimeDate" style="width: 100%;"></Date-picker>
              </Col>
            </Row>
          </Form-item>
          </Col>
          <Col :span="2">
          <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search"
                  @click="search" >搜索
          </Button>
          </Col>
        </Row>
      </Form>
    </div>
    <List ref="dataList" :tableColumns="title" :reload="reload" listUrl="/activityExamine/recordList"
          :params="queryParam" :onLoading="onLoading" operator=""></List>

  </div>

</template>
<script>
  export default {
    components: {
    },
    data () {
      let $constant = this.$constant
      return {
        searchLoading: false,
        exportLoading: false,
        showImgModal: false,
        showImgList: [],
        reload: 0,
        editUser: false,
        uid: null,
        queryParam: {
          uid: '',
          mobile: '',
          userNickname: '',
          adminNickname: '',
          adminMobile: '',
          startTimeDate: '',
          endTimeDate: '',
          startTime: '',
          endTime: '',
          status: null,
          type: '',
          tchId: null,
          subType: null,
          auditorName: ''
        },
        title: [
          {
            title: '学生ID/姓名',
            width: 150,
            render: (h, params) => {
              let row = params.row
              return h('a', {on: {click: () => this.openInfoModal(row.uid)}}, row.uid + '-' + row.userNickname)
            }
          },
          {
            title: '兑换类型',
            align: 'center',
            // width: 120,
            render: (h, params) => {
              let type = params.row.giveType
              let typeEnum = $constant.getEnum($constant.giveType, type)
              return h('div', typeEnum && typeEnum.text)
            }
          },
          {
            title: '课程赠送',
            align: 'center',
            key: 'lessonNum',
            // width: 110,
          },
          {
            title: '物品赠送',
            align: 'center',
            key: 'remark',
            // width: 120,
          },
          {
            title: '扣除积分',
            align: 'center',
            // width: 120,
            key: 'activity'
          },
          {
            title: '兑换时间',
            align: 'center',
            // width: 170,
            key: 'gmtCreate'
          },
          {
            title: '兑换人',
            // width: 120,
            align: 'center',
            key: 'creatorName'
          }
        ]
      }
    },
    mounted: function () {
    },
    created: function () {
    },
    methods: {
      viewPic (row) {
        this.showImgList = row.urls
        this.showImgModal = true
      },
      closeImgModal () {
        this.showImgList = []
        this.showImgModal = false
      },
      closeModal (val) {
        this.uid = null
        this.editUser = val
      },
      openInfoModal (val) {
        this.uid = val
        let {href} = this.$router.resolve({
          name: 'userPayDetail',
          query: {uid: val, tabName: 0, parm: self.queryParam, backPath: '/user/ExchangeRecordList'}})
        window.open(href, '_blank')
      },
      search () {
        this.reload = new Date().getTime()
      },
      onLoading (loading) {
        this.searchLoading = loading
      },

      startTimeDateChange (value) {
        this.queryParam.startTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X')
      },
      endTimeDateChange (value) {
        this.queryParam.endTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X')
      },

    }
  }

</script>



// WEBPACK FOOTER //
// ExchangeRecordList.vue?bfe6e656